<template>
 <div class="wrapper">  
<CButton   color="info" @click="openNew"><b>Add New Article</b></CButton>
  <CRow class="mt-3">
    <CCol sm="12" lg="4">
      <CCard  >
        <CCardHeader>
          <b>Article Category Detail</b> 
        </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol>
                <label> Category Title :  </label>
                <p > <b> {{ datas.data.title }} </b> </p> 
                <hr>
                <label> Category Subtitle :  </label>
                <p >  <b> {{ datas.data.subtitle }} </b> </p>
                <hr>
                <label> Card Image </label>
                <CRow >
                  <CCol >
                    <img class="mt-2" v-bind:src="datas.data.card_image" style="width:200px"/>
                  </CCol>
                </CRow>
              <hr>
              <label> Background Image </label>
              <CRow >
                <CCol >
                  <img class="mt-2" v-bind:src="datas.data.bg_image" style="width:200px"/>
                </CCol>
              </CRow>    
              </CCol>
            </CRow>  
          </CCardBody>  
      </CCard>
    </CCol>   
    <CCol sm="12" lg="8">
      <CCard>
        <CCardHeader>
          <b>Article List</b> 
        </CCardHeader>
          <CCardBody>      
              <Datatable 
                  :items="items" 
                  :fields="fields" 
                  :meta="meta" 
                  @per_page="handlePerPage" 
                  @pagination="handlePagination"
                  @search="handleSearch" 
                  @sort="handleSort"
                  @is_active="handleIsActive"
                  :btn_show="true"
                  :btn_edit="true"
                  :btn_deactivate="true"
                  :btn_reactivate="true"
                  :btn_destroy="true"
                  @showArticle="handleShowArticle"
                  @editArticle="handleEditArticle"
                  @publish="handlechangeToPublish"
                  @unpublish="handlechangeToUnpublish"
                  @deactivate="handleDeactivate"
                  @reactivate="handleReactivate"           
              />     
          </CCardBody>
      </CCard>
    </CCol>
  </CRow>
<!-- <pre>{{ $data | json }}</pre> -->

            
    <alertmodal></alertmodal>
    
  </div>
</template>

<script>
import Datatable from '@/components/datatables_article_detail.vue'
import alertmodal from '@/views/alert/modal.vue';
import articlecategory from '@/services/articlecategory'
import article from '@/services/article'
import EventBus from '@/eventBus';
import store from '@/store.js'
import moment from 'moment';
const token = localStorage.getItem('token');

export default {
  name: 'article',
  components: { alertmodal, Datatable},
  data(){
    return{
     
      updateSubmit: false,
      largeModal:false,
      mode:'',
      cardCollapse: true,
      datas:[],
       fields: [
          {key: 'title', sortable: false, },
          {key: 'author', sortable: false, },
          {key: 'publish_date', sortable: false, },
          {key: 'is_publish', sortable: false, },
          {key: 'is_active', sortable: false, },
          {key: 'action', label: 'Action', sortable: false, },
      ],
      items: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search:'',
      sortBy: '',
      sortByDesc: false,
      is_active: 1,
      //end
    }
    //end
  },

  created() {
      //this.loadData()
      
      
  },
  mounted (){
     this.loadData()

    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });
   },
   beforeDestroy() {
    // removing eventBus listener
    EventBus.$off('TABLE_UPDATE')
  },
   
  methods: {
    openNew: function (){
      this.$router.push({name:'Article Form'})
    },
     openShow(id){
      let routeData = this.$router.resolve({path: '/master/article/article/detail',query: {id:id} }) 
      window.open(routeData.href, '_blank');
        }, 
        openEdit(id){
      this.$router.push({name:'Article Form',query: {id:id} })
    },  
    publish(id){   
      if(confirm("Do you really want to publish this article?")){
        article.publishArticle(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
    },
     unpublish(id){   
       if(confirm("Do you really want to unpublish this article?")){
        article.unpublishArticle(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
      //SET END
    },
    deactivate(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Delete section') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to deactivate?")){
        article.deactivateArticle(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
       //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },

    reactivate(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Delete section') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to reactivate?")){
        article.reactivateArticle(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
       //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },

    destroy(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Delete section') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to delete?")){
        article.destroyArticle(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
       //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },

    loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
       
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
        }
        articlecategory.getArticleCategorybyID(this.$route.query.id,params)
        .then(res => {
          this.datas = res; 
          let getData = res.article_list
          this.items = getData.data
          //this.items = res.data.event_order
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active   
          }
          const formattedData = getData.data.map(item => {
            return{
              ...item,
              publish_date: moment(item.publish_date).format("DD/MM/YYYY")
            }
            })
          this.items = formattedData  
          
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShowArticle(val) {
        this.openShow(val) 
    }, 
    handleEditArticle(val) {
        this.openEdit(val) 
    },    
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handlechangeToPublish(val) {
        this.publish(val) 
    },  
    handlechangeToUnpublish(val) {
        this.unpublish(val)       
    },
    handleReactivate(val) {
        this.reactivate(val)       
    },
    handleDestroy(val) {
        this.destroy(val)       
    },
  }
}
</script>
